module.exports = __webpack_public_path__ + "img/couples_12_V.0471ee72.webp";